import { AuditLiveMention, AuditSchedule } from '@mi-front/core';
import { theme } from '@mi-front/ui';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { LDate } from '../../../../../../components/date/LDate';
import { LTime } from '../../../../../../components/date/LTime';

export const Wrapper = styled.div`
  font-size: 14px;
  line-height: 20px;
`;

export default function MentionConfirmedBySchedule(p: {
  match: AuditLiveMention;
  schedule: AuditSchedule;
}) {
  return (
    <Wrapper
      style={{
        color: theme.greenDark,
      }}
    >
      <div style={{ display: 'inline-block', marginRight: 6 }}>
        <ScheduleIcon sx={{ fontSize: 'inherit', verticalAlign: 'middle' }} />{' '}
        <FormattedMessage
          id="audit.matchesList.matchesWithSchedule"
          defaultMessage="Coincide con schedule"
        />{' '}
      </div>
      <Link
        to={`/audit/s/${p.schedule.stationId}/schedule/mentions/${p.schedule.id}`}
        target="_blank"
      >
        <LDate value={p.schedule.datetime} day="2-digit" month="2-digit" />{' '}
        <LTime value={p.schedule.datetime} />{' '}
        <OpenInNewIcon sx={{ fontSize: 'small', verticalAlign: 'middle' }} />
      </Link>
    </Wrapper>
  );
}
